import React from 'react';
import { Form1008Data, ValidationErrors } from '../../types';
import { TextInput } from '../ui/Inputs';
interface Props {
  data: Form1008Data;
  onChange: (field: keyof Form1008Data, value: any) => void;
  errors: ValidationErrors;
}
export function Section4({
  data,
  onChange,
  errors
}: Props) {
  return <>
      <div className="space-y-3" data-id="element-225">
        <div data-id="element-226">
          <h3 className="text-xs font-bold text-slate-500 mb-2 uppercase tracking-wider" data-id="element-227">
            Seller Details
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-2" data-id="element-228">
            <TextInput label="Seller Name" value={data.sellerName} onChange={v => onChange('sellerName', v)} required error={errors.sellerName} data-id="element-229" />
            <TextInput label="Seller No." value={data.sellerNumber} onChange={v => onChange('sellerNumber', v)} data-id="element-230" />
            <TextInput label="Investor Loan No." value={data.investorLoanNumber} onChange={v => onChange('investorLoanNumber', v)} data-id="element-231" />
            <TextInput label="Seller Address" value={data.sellerAddress} onChange={v => onChange('sellerAddress', v)} className="md:col-span-2" data-id="element-232" />
            <TextInput label="Seller Loan No." value={data.sellerLoanNumber} onChange={v => onChange('sellerLoanNumber', v)} data-id="element-233" />
          </div>

          <div className="pt-3 border-t border-slate-100" data-id="element-234">
            <h3 className="text-xs font-bold text-slate-500 mb-2 uppercase tracking-wider" data-id="element-235">
              Contact Information
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-2" data-id="element-236">
              <TextInput label="Contact Name" value={data.contactName} onChange={v => onChange('contactName', v)} required error={errors.contactName} data-id="element-237" />
              <TextInput label="Contact Title" value={data.contactTitle} onChange={v => onChange('contactTitle', v)} data-id="element-238" />
              <TextInput label="Contact Phone Number" value={data.contactPhone} onChange={v => onChange('contactPhone', v)} required error={errors.contactPhone} data-id="element-239" />
            </div>
          </div>
        </div>
      </div>
    </>;
}